import * as React from 'react'

import { FallbackImg, StyledPicture } from './styles'

type Props = {
  srcSet: string
  media?: string
  sizes?: string
  type?: string
  alt?: string
  style?: React.CSSProperties
}

export const Picture: React.SFC<Props> = props => {
  const { srcSet, media, sizes, type, alt, style } = props

  return (
    <StyledPicture>
      <source srcSet={srcSet} media={media} sizes={sizes} type={type} />
      <FallbackImg src={srcSet} alt={alt} style={style} />
    </StyledPicture>
  )
}
